import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

class FilterWithAuth extends React.Component {
    constructor() {
        super();
        this.state = {};
    }

    componentWillMount() {}

    render() {
        const { profileItems } = this.props.user;
        const { authRequired, isWriteAccess } = this.props;
        const result = profileItems.filter(o => authRequired.indexOf(o.uniqueName) > -1 && o.readAccess);
        if (result.length === 0) return null;
        if (isWriteAccess === true) {
            if (result.filter(o => o.writeAccess === true).length === 0) return null;
        }
        return this.props.children;
    }
}

FilterWithAuth.propTypes = {
    children: PropTypes.any,
    user: PropTypes.object.isRequired,
    authRequired: PropTypes.array.isRequired,
    isWriteAccess: PropTypes.bool,
};

FilterWithAuth.defaultProps = {
    isWriteAccess: false,
    children: '',
};

const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
});

export default connect(mapStateToProps, mapDispatchToProps)(FilterWithAuth);
